import React from 'react';
import '../../styles/Loader.css'; // We will create this file for loader specific styles

const Loader = () => {
  return (
    <div className="loader-container">
      <div className="loader"></div>
    </div>
  );
};

export default Loader;
